export default function PersonalDetails({ user }) {
  return (
    <>
      <div className="ibox-content">
        <div className="row">
          <div className="col-4">
            <h4>User ID</h4>
            <small className="stats-label">{user.user_id}</small>
          </div>
          <div className="col-4">
            <h4>First Name</h4>
            <small className="stats-label">{user.first_name}</small>
          </div>
          <div className="col-4">
            <h4>Last Name</h4>
            <small className="stats-label">{user.last_name}</small>
          </div>
          <div className="col-4">
            <h4>Phone</h4>
            <small className="stats-label">{user.phone}</small>
          </div>
          <div className="col-4">
            <h4>Email</h4>
            <small className="stats-label">{user.email_id}</small>
          </div>
          <div className="col-4">
            <h4>Status</h4>
            <small className="stats-label">{user.status}</small>
          </div>
        </div>
      </div>
      <div className="ibox-content">
        <h4>Favorite Restaurants</h4>
        {user.favorite.map((fav, key) => (
          <div className="row" key={key}>
            <div className="col-4">
              <h4>{fav}</h4>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
